import { buildDrupalMetatags } from "./../buildDrupalMetatags/index.js";
import {
  useNuxtApp,
  useHead,
  computed,
  navigateTo,
  createError,
  watch,
  useRoute,
  isRef
} from "#imports";
export async function useDrupalRoute(queryInput, options, providedRoute) {
  const app = useNuxtApp();
  const inputIsRef = isRef(queryInput);
  const query = computed(() => {
    if (!queryInput) {
      return;
    }
    if (queryInput !== null && "value" in queryInput && queryInput.value) {
      return queryInput.value;
    }
    if ("route" in queryInput) {
      return queryInput;
    }
  });
  const metatags = computed(
    () => buildDrupalMetatags(query.value)
  );
  useHead(metatags);
  const entity = computed(
    () => query.value?.route && "entity" in query.value.route && query.value.route.entity ? query.value.route.entity : void 0
  );
  const drupalRoute = computed(() => {
    const route = query.value?.route;
    if (route && "drupalRouteEntity" in route && route.drupalRouteEntity) {
      const entity2 = route.drupalRouteEntity;
      return {
        name: route.routeName,
        entityBundle: entity2.entityBundle,
        entityType: entity2.entityTypeId,
        entityId: entity2.id,
        entityUuid: entity2.uuid
      };
    } else if (route && "routeName" in route) {
      return {
        name: route.routeName || void 0
      };
    }
    return {};
  });
  const ctx = {
    entity,
    drupalRoute,
    metatags
  };
  const nuxtRoute = providedRoute ?? useRoute();
  const hookPayload = computed(() => ({
    path: nuxtRoute.path,
    drupalRoute: drupalRoute.value,
    metatags: metatags.value,
    routeQuery: query.value
  }));
  if (query.value?.route && "redirect" in query.value.route) {
    const redirectTarget = query.value.route.path;
    if (redirectTarget) {
      const target = redirectTarget.includes("?") ? redirectTarget : {
        path: redirectTarget,
        query: nuxtRoute.query
      };
      await navigateTo(target, {
        redirectCode: query.value.route.redirect?.statusCode ?? 301,
        replace: true,
        external: true
      });
    }
    return ctx;
  }
  const handleRoute = async () => {
    if ((!query.value?.route || !entity.value) && !options?.noError) {
      throw createError({
        statusCode: 404,
        statusMessage: "Page not found",
        fatal: true
      });
    }
    await app.callHook("vuepal:drupal-route", hookPayload.value);
  };
  if (import.meta.client && inputIsRef) {
    watch(query, handleRoute);
  }
  await handleRoute();
  return ctx;
}
